import React from "react";
import {FieldEditableProps} from "../../../../proto/render/editable";

type State = {
    showPopover : boolean
}

export default class FieldFormula_Editable extends React.Component<FieldEditableProps, State>{

    constructor(props:FieldEditableProps) {
        super(props)

        this.state = {
            showPopover : false
        }
    }

    onClick = () => {

        this.setState({
            showPopover     : !this.state.showPopover
        })

    }

    render() {

        const field = this.props.field
        // @ts-ignore
        const value = field.getDisplayValue(field.calculateValue(this.props.model))

        const classes = Classes("ui5-txt-default p-l-10")

        return (
            <div className={classes}
                 onClick={this.onClick}>
                <div className="max-w-100-percent txt-truncate">{value}</div>

                {this.state.showPopover &&
                    <field.components.PopoverMenu
                        parent={this}
                        field={this.props.field}
                        value={value}
                        model={this.props.model}
                    />
                }

            </div>
        )
    }
}
